import { useEffect, useState } from "react";
import axios from "axios";
import { Gift, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReferralBanner() {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("bc_ref_banner_dismissed") === "1");

  useEffect(() => {
    const code = localStorage.getItem("bc_ref_code");
    if (!code) return;
    axios
      .get(`${API}/referrals/validate/${code}`)
      .then((res) => {
        if (res.data.valid) setInfo(res.data);
        else localStorage.removeItem("bc_ref_code");
      })
      .catch(() => {});
  }, []);

  if (!info || dismissed) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-center gap-3 border-t border-terra/40 bg-pine px-5 py-3 text-bone"
      data-testid="referral-banner"
    >
      <Gift size={15} className="shrink-0 text-terra" />
      <p className="text-xs leading-snug md:text-sm">
        {info.referrer_first_name ? `${info.referrer_first_name} referred you` : "You were referred"} — you get{" "}
        <strong className="text-terra">{info.friend_discount_pct}% off</strong> your first paid service, applied automatically at checkout.
      </p>
      <button
        onClick={() => {
          setDismissed(true);
          sessionStorage.setItem("bc_ref_banner_dismissed", "1");
        }}
        aria-label="Dismiss referral banner"
        data-testid="referral-banner-dismiss"
        className="ml-2 text-bone/50 transition-colors hover:text-bone"
      >
        <X size={15} />
      </button>
    </div>
  );
}
